module.exports = __webpack_public_path__ + "img/beijing@2x.9bbca7f7.png";